import React from 'react';
import { Slider } from '@mui/material';
import Label from 'ui/elements/form/Label';

interface Props {
  value: number;
  onChange: (value: number) => void;
  className?: string;
}

const marks = [
  { value: 3, label: '3' },
  { value: 6, label: '6' },
  { value: 9, label: '9' },
  { value: 12, label: '12' },
  { value: 15, label: '15' },
  { value: 18, label: '18' },
  { value: 21, label: '21' },
  { value: 24, label: '24' },
];

export default function MaxDataPointsSlider({ value, onChange, className }: Props) {
  return (
    <div className={className}>
      <Label>Max Data Points (months)</Label>
      <Slider
        value={value}
        onChange={(_e: Event, newValue: number | number[]) => onChange(newValue as number)}
        min={3}
        max={24}
        step={3}
        marks={marks}
      />
    </div>
  );
}


